<template>
  <div id="app">
    <router-view/>
    <loader />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Loader from './components/misc/Loader'
export default {
  name: 'app',
  data(){
    return {
      defaultTitle: "Mi Brime",
    }
  },
  components: {
    Loader
  },
  created(){
    document.title = this.defaultTitle;
  }
}
</script>
